<div class="p-5 rounded bg-white shadow-[0_0px_8px_1px_rgba(0,0,0,0.1)]">
  <ng-content></ng-content>
</div>
